import text from './text.json'
import './index.scss'
import {ImgButton} from '../../components/core/button'
import {ButtonArrow, PageIsNotFound} from '../../icons'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import AddResourceModal from '../../components/pages/resource/AddResourceModal'
import Footer from '../../components/layouts/footer'
import NotFound from '../resources/NotFound'
import {routes} from '../../routes'
import {ResponsivePageTitle} from '../../components/core/title'
import {setModalIsActive} from '../../stores/resources'
import classNames from 'classnames'

const NotFoundPage = () => {
    const navigate = useNavigate()
    const modalIsActive = useSelector(state => state.resources.modalIsActive)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()

    const goToMainPage = () => {
        navigate(routes.resources.path)
    }
    return (
        <>
            <main className={classNames('main monitoring', {
                dark: isDarkMode
            })}>
                <ResponsivePageTitle/>
                <div className={classNames('not-found-container', {
                    dark: isDarkMode
                })}>
                    <div className="not-found-content">
                        <NotFound message={text.page_not_found} icon={<PageIsNotFound/>}/>
                        <ImgButton className="go-to-mainpage" onClick={goToMainPage}>
                            {text.go_to_mainpage}
                            <span><ButtonArrow/></span>
                        </ImgButton>
                    </div>
                </div>
                <Footer/>
            </main>
            {modalIsActive &&
                <AddResourceModal
                    closeModal={() => dispatch(setModalIsActive(false))} isOpen={modalIsActive}
                    title={text.add_new_resource} contentClassName="overflow-auto"/>
            }
        </>
    )
}

export default NotFoundPage
